// extracted by mini-css-extract-plugin
export default {"pill":"SubjectReviewList_pill__jgKEI","pillButton":"SubjectReviewList_pillButton__o8XPS"};